import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f459a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-text-[red]"
}
const _hoisted_2 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0.104884 1.50643L4.67976 6.69267C4.72096 6.73622 4.77061 6.7709 4.82567 6.79461C4.88073 6.81832 4.94005 6.83054 5 6.83054C5.05995 6.83054 5.11927 6.81832 5.17433 6.79461C5.22939 6.7709 5.27904 6.73622 5.32024 6.69267L9.89512 1.50643C9.93169 1.46523 9.95972 1.41717 9.97757 1.36506C9.99541 1.31294 10.0027 1.25779 9.99909 1.20282C9.99458 1.14741 9.97901 1.09346 9.95329 1.04417C9.92758 0.994883 9.89224 0.951249 9.84937 0.915852L9.07996 0.27121C9.03793 0.234855 8.98904 0.207291 8.93618 0.190147C8.88332 0.173003 8.82756 0.166627 8.77219 0.171394C8.71709 0.175381 8.66333 0.190306 8.61406 0.215299C8.56479 0.240292 8.52099 0.274851 8.48522 0.316959L5.0707 4.24719C5.04968 4.26802 5.02128 4.2797 4.99168 4.2797C4.96209 4.2797 4.93369 4.26802 4.91266 4.24719L1.51478 0.316958C1.44755 0.236653 1.35249 0.18467 1.2486 0.171394C1.19352 0.16606 1.13793 0.171774 1.08508 0.1882C1.03223 0.204625 0.983193 0.231432 0.940838 0.267051L0.150633 0.915852C0.107763 0.951249 0.0724248 0.994883 0.0467083 1.04417C0.0209918 1.09346 0.0054186 1.14741 0.000909419 1.20282C-0.00273159 1.25779 0.00458484 1.31294 0.0224338 1.36506C0.0402828 1.41717 0.0683087 1.46523 0.104884 1.50643Z",
  fill: "#387DFF"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { ref } from "vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { PropType } from "vue";
import BaseDropDown from "../common/form/baseDropDown.vue";
import VRuntimeTemplate from "vue3-runtime-template";


export default /*#__PURE__*/_defineComponent({
  __name: 'wizardDropdownQuestion',
  props: {
  title: { type: String, required: true },
  classTitle: { type: String, required: false, default: "" },
  placeholder: { type: String, required: true },
  dropdownData: {
    type: Array as PropType<IDropDownData[]>,
    required: false,
    default: () => [],
  },
  required: { type: Boolean, required: false, default: false },
  currentType: { type: Object, required: false, default: () => {} },
  typeId: { type: String, required: false, default: null },
  validation: { type: Object, required: false, default: null },
  index: { type: Number, required: false, default: 0 },
  colInput: { type: Number, required: false, default: 6 },
  dropdownClass: { type: String, required: false, default: "" },
  isApiError: { type: Boolean, required: false, default: false },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;



const curentValue = ref(props.currentType?.name || null);
const isDropdownOpen = ref(false);


const handleClick = (dataId, data) => {
  curentValue.value = data.name;
  emit("update:modelValue", data);
};

const toKebabCase = (str) => {
  return str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_row, {
      class: _normalizeClass('row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center')
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", {
              class: _normalizeClass([
            'tw-mb-0 tw-text-[13px] tw-text-[#231F20] tw-leading-[145%] tw-font-medium tw-font-Poppins',
            __props.classTitle,
          ])
            }, _toDisplayString(__props.title), 3),
            (__props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, " *"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          class: _normalizeClass(`col-sm-${__props.colInput} tw-pr-0 tw-pl-0`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(`dropdown ${__props.dropdownClass}`)
            }, [
              _createVNode(BaseDropDown, {
                id: 
              'goals-dropdown-wizard-dropdown-' +
              toKebabCase(__props.title) +
              '-' +
              __props.index
            ,
                "model-value": curentValue.value,
                data: __props.dropdownData,
                validation: __props.validation || {},
                "class-name": `gray-dropdown-container tw-h-[56px] ${
              __props.isApiError ? 'is-api-error' : ''
            }`,
                "onUpdate:openDropdown": _cache[0] || (_cache[0] = ($event: any) => (isDropdownOpen.value = $event)),
                "onUpdate:modelValue": handleClick
              }, {
                "button-content": _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`tw-text-[13px] ${
                    curentValue.value ? 'tw-text-[#000]' : 'tw-text-[#B7B7B7]'
                  }  tw-leading-[100%] tw-font-normal tw-font-Poppins`)
                    }, _toDisplayString(curentValue.value ? curentValue.value : __props.placeholder), 3),
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(`right-icon-arrow ${
                    isDropdownOpen.value ? 'tw-rotate-180' : ''
                  }`),
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "10",
                      height: "7",
                      viewBox: "0 0 10 7",
                      fill: "none"
                    }, _hoisted_4, 2))
                  ])
                ]),
                _: 1
              }, 8, ["id", "model-value", "data", "validation", "class-name"])
            ], 2)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, { class: "align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center')
        }),
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-sm-6 tw-pr-0 tw-pl-0')
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "feedback", {}, () => [
              _createVNode(_component_b_form_invalid_feedback, {
                class: _normalizeClass({ 'is-invalid': __props.validation?.$error })
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VRuntimeTemplate), {
                    template: __props.validation?.$errors?.[0]?.$message
                  }, null, 8, ["template"])
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ]))
}
}

})